
export default {
    name: 'param-etat-seins',
    components: {},
    props: {
        params_cpn: Object,
    },
    data() {
        return {
            fields: [
				'libelle',  { key: 'actions', label: 'Action.s' }
			],
			perPage: -1,
			currentPage: 1,
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {

    }
}